import { useContent } from '@/content'
import { useDocumentMeta } from '@/hooks'
import { ROUTES } from '@/lib/paths'
import { Button, Reveal, Section } from '@/components/ui'
import { DomainBoard } from '@/features/domains'
import { IntroScene } from '@/features/intro'
import { HeroSection } from '@/features/hero'
import { ProjectGrid } from '@/features/projects'
import { SocialPanels } from '@/features/social'
import styles from './HomePage.module.css'

/**
 * Landing page.
 *
 * Opens with the entry, introduces him, then states the organising idea —
 * three domains — and shows the strongest evidence for it.
 *
 * The name is not repeated at full size below the fold: the entry has
 * already said it, and saying it twice was the single biggest piece of
 * duplication on the site.
 */
export const HomePage = () => {
  const { projects, site } = useContent()
  useDocumentMeta({
    title: `${site.owner} — ${site.role}`,
    description: site.tagline,
  })

  const featured = projects.filter((project) => project.featured).slice(0, 2)

  return (
    <>
      <IntroScene />

      <div className={styles.content}>
        {/*
          * Him first, then the taxonomy.
          *
          * The page used to go from the entry straight into "Three domains",
          * which is a filing system presented to someone who has so far only
          * learned a name. The introduction gives the domains something to
          * be about.
          */}
        <HeroSection />

        <Reveal>
          <Section>
            <DomainBoard />
          </Section>
        </Reveal>

        <Reveal>
          <Section
            innerClassName={styles.workHead}
            aria-labelledby="featured-work"
          >
            <div className={styles.headRow}>
              <h2 id="featured-work" className="t-24">
                Selected work
              </h2>
              <Button to={ROUTES.projects} variant="bare" icon="arrowUpRight">
                All projects
              </Button>
            </div>
            <ProjectGrid projects={featured} />
          </Section>
        </Reveal>

        <Reveal>
          <SocialPanels />
        </Reveal>
      </div>
    </>
  )
}
